import { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";
import { setSiteUrl } from "./format";

const EMPTY = { loaded: false, whatsapp_number: "", phone: "", public_email: "", social: {}, company: {}, export_page: null, privacy_page: {}, legal_page: {}, line_url: "", homepage: null };
const SiteSettingsCtx = createContext(EMPTY);

export const SiteSettingsProvider = ({ children }) => {
  const [s, setS] = useState(EMPTY);
  useEffect(() => {
    api.get("/settings/public").then((r) => { setSiteUrl(r.data.site_url); setS({ ...EMPTY, ...r.data, loaded: true }); }).catch(() => setS((x) => ({ ...x, loaded: true })));
  }, []);
  return <SiteSettingsCtx.Provider value={s}>{children}</SiteSettingsCtx.Provider>;
};

export const useSiteSettings = () => useContext(SiteSettingsCtx);

export const localized = (field, lang) => (field ? field[lang] || field[lang === "ja" ? "en" : "ja"] || "" : "");
